import React from 'react';
import { useWatch } from 'react-hook-form';
import useMeasureFilterFormContext from '../../utils/useMeasureFilterFormContext';
import { RelationalOperatorKey } from '../../../../../../../utils/apollo/graphqlSchema';
import SingleMeasureFilterBetweenValues from './SingleMeasureFilterBetweenValues';
import SingleMeasureFilterValue from './SingleMeasureFilterValue';

interface IProps {
  filterIndex: number;
}

const SingleMeasureFilterValues = ({ filterIndex }: IProps) => {
  const { control } = useMeasureFilterFormContext();

  const relOpKey = useWatch({
    name: `filters.${filterIndex}.relOpKey`,
    control,
  });

  if (relOpKey === RelationalOperatorKey.Between) {
    return <SingleMeasureFilterBetweenValues filterIndex={filterIndex} />;
  }

  return <SingleMeasureFilterValue filterIndex={filterIndex} />;
};

export default SingleMeasureFilterValues;
